import "./App.css";
import ExampleComponent from "./components/example-component/Button";
// Modified the default react app to create this
function App() {
  return (
    <div className="App">
      <div className="container">
        <h2 className="is-title-8">Simple Hover Effect example </h2>
        <ExampleComponent />
      </div>
    </div>
  );
}

export default App;
